import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from 'compob2b-auth';
import {CreateUpdateDamComponent} from './create-update/create-update-dam.component';
import {DamCatalogLazyComponent} from './dam-lazy-tree/dam-catalog-lazy.component';
import {CreateUpdateDamPersonComponent} from './dam-person/create-update-dam-collections/create-update-dam-person.component';
import {DamPersonListComponent} from './dam-person/list/dam-person-list.component';
import {
  CreateUpdateDamRelatedCollectionComponent
} from './dam-related-collections/create-update-dam-collections/create-update-dam-related-collecton.component';
import {DamRelatedCollectionListComponent} from './dam-related-collections/list/dam-related-collection-list.component';
import {BasketTableLogListComponent} from './files/basket-table-log/list/basket-table-log-list.component';
import {BasketListComponent} from './files/basket/basket-list.component';
import {YandexImportComponent} from './yandex-import/yandex-import.component';

const routes: Routes = [
  {
    path: '', // path is: cabinet/dam
    component: DamCatalogLazyComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: ':menu_id/files',
        loadChildren: () => import('./files/dam-files.module').then(m => m.DamFilesModule),
        canActivate: [AuthGuardService],
      },
      {
        path: '',
        loadChildren: () => import('./files/dam-files.module').then(m => m.DamFilesModule),
        canActivate: [AuthGuardService]
      },
      // {
      //   path: 'shared-links',
      //   component: SharedLinksComponent,
      //   canActivate: [AuthGuardService],
      //   data: {testData: 'testData shared-links'}
      // },
      // {
      //   path: '',
      //   loadChildren: () => import('./pages/dam-pages.module').then(m => m.DamPagesModule),
      //   canActivate: [AuthGuardService]
      // },
      {
        path: 'edit/:id',
        component: CreateUpdateDamComponent,
        canActivate: [AuthGuardService]
      },
      // {
      //   path: 'edit/:id/history',
      //   component: FolderChangeHistoryComponent,
      //   canActivate: [AuthGuardService]
      // },
    ]
  },
  {
    path: 'dam-related-collection',
    component: DamRelatedCollectionListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'dam-person',
    component: DamPersonListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'basket/log',
    component: BasketTableLogListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'basket',
    component: BasketListComponent,
    canActivate: [AuthGuardService]
  },

  {
    path: 'dam-person/create',
    component: CreateUpdateDamPersonComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'dam-person/edit/:id',
    component: CreateUpdateDamPersonComponent,
    canActivate: [AuthGuardService]
  },

  {
    path: 'yandex-import',
    component: YandexImportComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'dam-related-collection/create',
    component: CreateUpdateDamRelatedCollectionComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'dam-related-collection/edit/:id',
    component: CreateUpdateDamRelatedCollectionComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'create',
    component: CreateUpdateDamComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'create/:parent',
    component: CreateUpdateDamComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'edit/:id',
    component: CreateUpdateDamComponent,
    canActivate: [AuthGuardService]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DamRoutingModule {
}
